import { NavLink, Link } from "react-router-dom";
import ProductAccordion from "../product-accordion/ProductAccordion";

const SideBar = () => {
  return (
    <div className="sideBar">
      <div style={{marginBottom:100}}>
        <img src="/assets/images/logos/SidebarLogo.svg" alt="" width={150}/>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
          marginBottom:20
        }}
      >
        <a href="https://dashboard.spaybusiness.com/"  className="side_nav_side">
          <div><p>Sign In</p></div>
        </a>
        <Link to={"https://dashboard.spaybusiness.com/register/"} className="side_nav_side2">
          <div><p>Sign Up</p></div>
        </Link>
      </div>
      <div>
        <ProductAccordion />
      </div>

      <NavLink to="/contact-sales" className="side_nav_contact">
        <div >Contact Sales</div>
      </NavLink>
    </div>
  );
};

export default SideBar;
